import { makeStyles } from '@rbx/ui';
import {
  engineRevampMonospaceTextStyle,
  stickyBreadcrumbScrollOffset,
} from '@modules/ui/shared/utils/styles';

const useReferenceSummaryMemberTableStylesV2 = makeStyles()((theme) => {
  return {
    tableContainer: {
      marginBottom: '24px',
      scrollMarginTop: stickyBreadcrumbScrollOffset,
    },
    table: {
      border: `1px solid ${theme.palette.components.divider}`,
      borderRadius: '4px',
      borderCollapse: 'separate',
      overflow: 'hidden',
    },
    tableRow: {
      '& td': {
        padding: '8px 12px 8px 8px',
        borderBottom: `1px solid ${theme.palette.components.divider}`,
      },
      '&:last-child td': {
        borderBottom: 'none',
      },
    },
    cellContent: {
      display: 'flex',
      alignItems: 'center',
      minHeight: '25px', // Ensure height when no icon is present
      gap: '8px',
    },
    iconWrapper: {
      display: 'flex',
      alignItems: 'center',
      flexShrink: 0,
    },
    memberText: {
      ...engineRevampMonospaceTextStyle,
    },
    deprecatedMemberText: {
      ...engineRevampMonospaceTextStyle,
      color: theme.palette.content.disabled,
      '& *': {
        color: `${theme.palette.content.disabled} !important`,
      },
    },
    titleLink: {
      ...engineRevampMonospaceTextStyle,
      display: 'inline',
      color: theme.palette.content.standard,
      lineHeight: '140%',
      marginRight: '4px',
    },
    parameters: {
      ...engineRevampMonospaceTextStyle,
      marginRight: '4px',
    },
    parameter: {
      ...engineRevampMonospaceTextStyle,
      whiteSpace: 'nowrap',
      display: 'inline-block',
    },
    parameterComma: {
      ...engineRevampMonospaceTextStyle,
      marginRight: '4px',
    },
    parameterType: {
      ...engineRevampMonospaceTextStyle,
      cursor: 'pointer',
      display: 'inline-block',
      color: theme.palette.content.standard,
      position: 'relative',
    },
    dashedTypeWrapper: {
      // note: pseudoselectors don't work with makeStyles -> need global classname
      '& .dashedType:before': {
        borderBottomStyle: 'solid',
        borderBottomWidth: '1px',
        position: 'absolute',
        content: '" "',
        display: 'block',
        bottom: 0,
        // border bottom is not quite flush to the left.
        // off by 0.25px
        left: 0.25,
        right: 0,
      },
    },
    inheritedGroupTitle: {
      ...engineRevampMonospaceTextStyle,
      lineHeight: '100%',
    },
    memberTypeTooltip: {
      padding: '12px 8px',
      '& .tooltipBody': {
        margin: '8px 0 0',
        color: theme.palette.content.standard,
      },
      '& .tooltipSubtitle': {
        display: 'block',
        margin: '8px 0 0',
        fontWeight: 300,
        fontSize: 14,
      },
    },
    memberTypeTooltipLink: {
      textDecoration: 'underline',
    },
    tagWrapper: {
      whiteSpace: 'nowrap',
      '&.engine': {
        marginTop: 4,
        marginLeft: '8px',
        marginBottom: '4px',
      },
      '&:first-child': {
        marginLeft: 0,
      },
    },
    tagLabel: {
      textTransform: 'capitalize',
    },
    tagTooltip: {
      margin: 0,
      padding: '12px 8px',
      minWidth: 10,
    },
  };
});

export default useReferenceSummaryMemberTableStylesV2;
